fragment ProductInformationFragment on productInformation_Entry {
  typeHandle
}
